import AuraFaceView from "./AuraFaceView";

export default function AuraPage() {
  return (
    <div style={{ width: "100vw", height: "100dvh", background: "#000" }}>
      <AuraFaceView />
    </div>
  );
}
